import { Grid } from "@mui/material";
import { AppWidgetSummary } from "src/sections/@dashboard/app";

const PackStatWidget = ({ title, total, icon, color }) => {
  return (
    <Grid item xs={12} sm={6} md={4}>
      <AppWidgetSummary title={title} total={total} icon={icon} color={color} />
    </Grid>
  );
};

export default PackStatWidget;
